module.exports = ".ui-fileupload .ui-corner-top {\r\n  border-top-left-radius: 2px;\r\n  border-top-right-radius: 2px;\r\n}\r\n.ui-fileupload .ui-corner-bottom {\r\n  border-bottom-left-radius: 2px;\r\n  border-bottom-right-radius: 2px;\r\n}\r\n.ui-fileupload .ui-button {\r\n  border-radius: 2px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/primeng/file-upload/css/primeng.file-upload.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/primeng/file-upload/css/primeng.file-upload.css
// module chunks = styles